import React from 'react'
import PropTypes from 'prop-types'

import { JwtIframe } from '@eqworks/common-login'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 64px)',
  },
}))


const IframeContainer = ({ children, title }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {typeof children === 'string' ? (
        <JwtIframe title={title}>{children}</JwtIframe>
      ) : children}
    </div>
  )
}
IframeContainer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}
IframeContainer.defaultProps = { title: 'Iframe Container', children: null }

export default IframeContainer
